// mutations
const SET_TEMPSERAGAM = (state, payload) => {
  state.temp_seragam = payload;
};
const SET_USERID = (state, payload) => {
  state.user_id = payload;
};
const SET_IDSERAGAM = (state, payload) => {
  state.id_seragam = payload;
};
const SET_RESSERAGAMBYID = (state, payload) => {
  state.res_seragamById = payload;
};
const SET_USERS = (state, payload) => {
  state.users = payload;
};
const SET_SELECTED_KARYAWAN = (state, payload) => {
  state.karyawan_selected = payload;
};
export default {
  SET_TEMPSERAGAM,
  SET_USERID,
  SET_IDSERAGAM,
  SET_USERS,
  SET_SELECTED_KARYAWAN,
  SET_RESSERAGAMBYID
};
